import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../../context/tenant-context';
import { v2Component } from '../../../../index';
import { ToastContainer } from 'react-toastify';
import { ProductDescriptionForm } from './product-description-form';

export function initProductDescriptionForm(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-description-form');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootDescription = (desc: string) => {
        element.setAttribute('data-description', desc);
      };

      const bootstrap = () => {
        const { tenant, contextPath, name, description, ...props } = Object.assign({}, element.dataset) as any;

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductDescriptionForm
                productName={name}
                currentDescription={description}
                setRootDescription={setRootDescription}
                {...props}
              />
            </TenantContext.Provider>,
          ),
        );
        const event = new CustomEvent('change');
        element.dispatchEvent(event);
      };

      bootstrap();
    }
  });
}
